import React from "react"

export const Dash = props => {
  return <span>&nbsp;—&nbsp;</span>
}
